import React from "react";
import "./HomePageContent.css";

const HomePageContent = () => {
  return (
    <div className="qrp-container">
      <div className="qrp-banner">
        <img
          src={process.env.PUBLIC_URL + "/Images/HomePage/main-banner.jpg"}
          alt="QRP-banner"
        />
        <h1>Quantum Reinvent Program</h1>
        <span>Go full stack on fast track</span>
      </div>

      <div className="qrp-content">
        <section className="qrp-wrapper">
          <div className="qrp-content">
            <p className="qrp-text">
              The <span className="qrp-bold">Quantum Reinvent Program</span> is
              a role-based, AI-augmented learning initiative designed to
              transform skill development into measurable project readiness. It
              empowers professionals to build the right capabilities at the
              right time—aligned to real project and enterprise needs.
            </p>

            <p className="qrp-text">
              At the core of the program is a Cluster-based learning model,
              where a defined Role combined with essential Skills forms a
              focused capability cluster. Each cluster is{" "}
              <span className="qrp-bold">
                purposefully designed to deliver measurable value to learners
                while driving meaningful impact
              </span>{" "}
              for the organization.
            </p>
          </div>

          <div className="qrp-image-container">
            <img
              src={
                process.env.PUBLIC_URL + "/Images/HomePage/QrpIllustration.png"
              }
              alt="Quantum Reinvent Illustration"
              className="qrp-image"
            />
          </div>
        </section>
        <h1 className="qrp-blueprint">
          Our Blueprint for Building an
          <span> AI - Forward Workforce</span>
        </h1>
        <section className="airoles-wrapper">
          <div className="airoles-card">
            <img
              src={process.env.PUBLIC_URL + "/Images/HomePage/AI-left.png"}
              alt="AI Role Interaction"
              className="airoles-image"
            />

            <p className="airoles-text">
              These roles are powered by a balanced skill model spanning Core
              IT, AI-savvy capabilities, Human skills, Industry domain
              expertise, and Functional knowledge, recognizing that true impact
              is created at the intersection of these competencies. By
              clustering high-value skills and anchoring delivery through AI
              Native Engineers, Reinvention Deployed Engineers, and Frontier
              Specialists, ATCI accelerates AI adoption, modernizes enterprises,
              and delivers intelligent, resilient, and human-centered solutions.
            </p>

            <div className="airoles-divider" />
          </div>

          <div className="airoles-card">
            <img
              src={process.env.PUBLIC_URL + "/Images/HomePage/AI-right.png"}
              alt="AI Robotics Automation"
              className="airoles-image"
            />

            <p className="airoles-text">
              Our AI-forward workforce blueprint redefines how we deliver value
              in an AI-driven world by combining evolving roles with
              future-ready skills. We organize work around five
              contribution-based roles— Conceptualizers, Creators, Conductors,
              Curators, and Custodians—that collectively shape solutions, build
              intelligent systems, orchestrate delivery, evolve technical
              foundations, and ensure operational excellence.
            </p>

            <div className="airoles-divider" />
          </div>
        </section>

        <section className="pa-section">
          <div className="pa-left">
            <div>
              <h2 className="pa-left-title">Who Is This Program For?</h2>

              <p className="pa-left-text">
                The Quantum Reinvent Program is applicable to all ASEs and
                serves as a structured pathway to accelerate capability
                development and project readiness from day one, while enabling
                working professionals to progress alongside their project
                commitments.
              </p>
            </div>

            <img
              src={process.env.PUBLIC_URL + "/Images/HomePage/icon-2.png"}
              alt="Program audience illustration"
              className="pa-left-image"
            />
          </div>

          <div className="pa-right">
            <div className="pa-right-main">
              <div className="pa-right-header">
                <h2 className="pa-right-title">
                  Flexible Learning for Working Professionals
                </h2>

                <img
                  src={process.env.PUBLIC_URL + "/Images/HomePage/icon-1.png"}
                  alt="Flexible learning illustration"
                  className="pa-right-image"
                />
              </div>

              <p className="pa-right-text">
                Learning is designed to fit seamlessly alongside project
                commitments through a blended approach:
              </p>

              <ul className="pa-list">
                <li>Self-paced learning for flexibility and autonomy</li>
                <li>
                  VALT (Virtual Applied Learning & Training) for hands-on,
                  guided experience
                </li>
              </ul>
            </div>

            <div className="pa-right-footer">
              This enables continuous progression without disrupting ongoing
              project delivery
            </div>
          </div>
        </section>

        <div>
          <h1 className="qrp-program-heading">
            A Structured, Future-Ready Program Framework
          </h1>
          <h6 className="qrp-sub-heading">
            Each capability cluster integrates:
          </h6>
        </div>

        <section className="cap-strip">
          <div className="cap-item">
            <img
              src={process.env.PUBLIC_URL + "/Images/HomePage/icon-3.png"}
              alt="Core skills"
              className="cap-icon"
            />
            <div className="cap-divider"></div>
            <p className="cap-text">
              Core technical skills,
              <br />
              delivered through
              <br />
              three complementary
              <br />
              schools
            </p>
          </div>

          <div className="cap-item">
            <img
              src={process.env.PUBLIC_URL + "/Images/HomePage/icon-4.png"}
              alt="AI augmented"
              className="cap-icon"
            />
            <div className="cap-divider"></div>
            <p className="cap-text">
              AI-augmented
              <br />
              capabilities to enhance
              <br />
              productivity and
              <br />
              decision-making
            </p>
          </div>

          <div className="cap-item">
            <img
              src={process.env.PUBLIC_URL + "/Images/HomePage/icon-5.png"}
              alt="Enterprise skills"
              className="cap-icon"
            />
            <div className="cap-divider"></div>
            <p className="cap-text">
              Critical enterprise skills
              <br />
              required for today’s
              <br />
              dynamic business
              <br />
              environment
            </p>
          </div>
        </section>

        <div className="cap-footer">
          This holistic approach ensures learners gain not only technical depth
          but also the agility and mindset needed for enterprise success.
        </div>

        <div className="explore-program-content">
          <h1 className="qrp-program-heading">Explore the Complete Program</h1>
          <p className="sub-heading">
            Discover the full program structure, learning clusters, and
            capability pathways designed to help you learn with purpose, apply
            with confidence, and deliver with impact.
          </p>
          <h1 className="program-heading">Entry Level Training</h1>
          <p className="sub-heading">
            This learning journey outlines the end-to-end post-onboarding
            development path for ASEs, where AI capabilities are seamlessly
            embedded into the Full Stack curriculum to drive faster project
            readiness, productivity, and certification outcomes. ASEs progress
            through a structured, milestone-based pathway starting from
            foundational proficiency and advancing toward TQR certification
            combining strong technical grounding with AI-enabled development and
            real-world application.
          </p>
        </div>

        <img
          src={
            process.env.PUBLIC_URL +
            "/Images/HomePage/skill-development-journey.png"
          }
          alt="Skill Development Journey"
          className="skill-development-img"
        />

        <h1 className="onboard-heading">
          AI learning integrated with Full Stack curriculum -
          <br />
          ASEs Post Onboard Learning
        </h1>

        <div className="onboard-learning">
          <div className="onboard-learning-left">
            <section className="csf-wrapper">
              <div className="csf-left">
                <img
                  src={process.env.PUBLIC_URL + "/Images/HomePage/icon-6.png"}
                  alt="P2 Icon"
                  className="csf-p2-icon"
                />

                <div className="csf-left-text">
                  <b>P2</b>
                  <span> Proficient in</span>
                  <b> Skill 1</b>
                </div>

                <div className="csf-arrows">
                  <img
                    src={process.env.PUBLIC_URL + "/Images/HomePage/icon10.png"}
                    alt="arrow"
                    className="p2-arrows"
                  />
                  <img
                    src={process.env.PUBLIC_URL + "/Images/HomePage/icon10.png"}
                    alt="arrow"
                    className="p2-arrows"
                  />
                </div>
              </div>

              <div className="csf-core-container">
                <div className="csf-core-label">CORE SKILLS</div>

                <div className="csf-core-box">
                  <div className="csf-core-row">
                    <div className="csf-card">
                      <img
                        src={
                          process.env.PUBLIC_URL + "/Images/HomePage/icon-7.png"
                        }
                        alt="School"
                      />
                      <div className="csf-card-title">School 1**</div>
                    </div>

                    <div className="csf-assessment">
                      <div className="icon-flex">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/Images/HomePage/icon-8.jpg"
                          }
                          alt="Assessment"
                        />
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/Images/HomePage/icon9.png"
                          }
                          alt="Assessment"
                          style={{ width: "17px", height: "17px" }}
                        />
                      </div>
                      <span>
                        Hands on
                        <br />
                        assessments
                      </span>
                    </div>

                    <div className="csf-card">
                      <img
                        src={
                          process.env.PUBLIC_URL + "/Images/HomePage/icon-7.png"
                        }
                        alt="School"
                      />
                      <div className="csf-card-title">School 2**</div>
                    </div>

                    <div className="csf-assessment">
                      <div className="icon-flex">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/Images/HomePage/icon-8.jpg"
                          }
                          alt="Assessment"
                        />
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/Images/HomePage/icon9.png"
                          }
                          alt="Assessment"
                          style={{ width: "17px", height: "17px" }}
                        />
                      </div>
                      <span>
                        Hands on
                        <br />
                        assessments
                      </span>
                    </div>

                    <div className="csf-card">
                      <img
                        src={
                          process.env.PUBLIC_URL + "/Images/HomePage/icon-7.png"
                        }
                        alt="School"
                      />
                      <div className="csf-card-title">School 3**</div>
                    </div>

                    <div className="csf-assessment">
                      <div className="icon-flex">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/Images/HomePage/icon-8.jpg"
                          }
                          alt="Assessment"
                        />
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/Images/HomePage/icon9.png"
                          }
                          alt="Assessment"
                          style={{ width: "17px", height: "17px" }}
                        />
                      </div>
                      <span>
                        Hands on
                        <br />
                        assessments
                      </span>
                    </div>
                  </div>

                  <div className="csf-bottom-strip">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/Images/HomePage/icon11.jpg"
                      }
                      alt="arrow"
                      className="bottom-arrow"
                    />
                    <span>
                      Quizzes, Daily Coding Challenge, Hands on Practice
                    </span>
                    <img
                      src={
                        process.env.PUBLIC_URL + "/Images/HomePage/icon12.jpg"
                      }
                      alt="arrow"
                      className="bottom-arrow"
                    />
                  </div>
                </div>
              </div>
            </section>

            <section className="aae-wrapper">
              <div className="aae-header">AI AUGMENTED SKILLS & ECOSYSTEM</div>

              <div className="aae-container">
                <div className="aae-completed">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/Images/HomePage/icon-16.png"
                    }
                    alt="completed arrow"
                    className="dotted-arrow"
                  />
                  <span style={{ paddingBottom: "20px", fontSize: "12px" }}>
                    Completed
                  </span>
                  <img
                    src={
                      process.env.PUBLIC_URL + "/Images/HomePage/icon-17.png"
                    }
                    alt="completed arrow"
                    className="dotted-arrow"
                  />
                </div>

                <div className="aae-left">
                  <div className="aae-card">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/Images/HomePage/icon-13.png"
                      }
                      alt="Gen AI"
                    />
                    <p>
                      GEN AI in TDLC
                      <br />
                      LEVEL 1 & 2
                    </p>
                  </div>

                  <div className="aae-list">
                    <ul>
                      <li>AGENTIC AI ECOSYSTEM TOOLS LEVEL 3A</li>
                      <li>AGENTIC AI FRAMEWORKS LEVEL 3B</li>
                      <li>
                        AGENTIC AI CLOUD NATIVE LEVEL 3C
                        <br />
                        (as applicable)
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="aae-right">
                  <div className="aae-highlight">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/Images/HomePage/icon-14.png"
                      }
                      alt="Agentic AI"
                    />
                    <p>AGENTIC AI ACCENTURE ASSETS LEVEL 4 (5 Hrs)</p>
                  </div>

                  <div className="aae-wip">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/Images/HomePage/icon-18.png"
                      }
                      alt="WIP arrows"
                      className="bend-arrows"
                    />
                    <span style={{ paddingTop: "10px", fontSize: "11px" }}>
                      WIP (GenWizard) **
                    </span>
                    <img
                      src={
                        process.env.PUBLIC_URL + "/Images/HomePage/icon-19.png"
                      }
                      alt="WIP arrows"
                      className="bend-arrows"
                    />
                  </div>
                </div>
              </div>

              <div className="aae-footnote">
                **Level 3A (and 3C as applicable) integrated as part of Tech
                skill Learning as well
              </div>
            </section>

            <section className="cas-wrapper">
              <div className="cas-header">CRITICAL ADDITIONAL SKILLS</div>

              <div className="cas-container">
                <div className="cas-card">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/Images/HomePage/icon-20.png"
                    }
                    alt="Industry Skill"
                  />
                  <span>Industry Skill</span>
                </div>

                <div className="cas-card">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/Images/HomePage/icon-21.png"
                    }
                    alt="Behavioural Skill"
                  />
                  <span>Behavioural Skill</span>
                </div>

                <div className="cas-card">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/Images/HomePage/icon-22.png"
                    }
                    alt="Delivery Skill"
                  />
                  <span>Delivery Skill</span>
                </div>
              </div>
            </section>
          </div>
          <section className="ctt-wrapper">
            <div className="ctt-card">
              <img
                src={process.env.PUBLIC_URL + "/Images/HomePage/icon-23.png"}
                alt="Capstone Project"
                className="ctt-capstone-icon"
              />
              <div className="ctt-card-text">Capstone Project</div>
            </div>

            <img
              src={process.env.PUBLIC_URL + "/Images/HomePage/icon-25.png"}
              alt="Down Arrow"
              className="ctt-arrow"
            />

            <div className="ctt-result">
              <img
                src={process.env.PUBLIC_URL + "/Images/HomePage/icon-24.png"}
                alt="TQR Certified"
                className="ctt-tqr-icon"
              />
              <div className="ctt-result-text">TQR Certified</div>
            </div>
          </section>
        </div>

        <div className="curriculum-heading">
          <p>
            The curriculum is structured into three progressive learning blocks
            with ongoing practice and assessment through
          </p>
        </div>

        <section className="la-wrapper">
          <div className="la-cards">
            <div className="la-card">
              <img
                src={process.env.PUBLIC_URL + "/Images/HomePage/icon-26.png"}
                alt="Quizzes"
              />
              <span>Quizzes</span>
            </div>

            <div className="la-card">
              <img
                src={process.env.PUBLIC_URL + "/Images/HomePage/icon-27.png"}
                alt="Daily Coding Challenges"
              />
              <span>Daily Coding Challenges</span>
            </div>

            <div className="la-card">
              <img
                src={process.env.PUBLIC_URL + "/Images/HomePage/icon-28.png"}
                alt="Hands-on Exercises"
              />
              <span>Hands-on Exercises</span>
            </div>

            <div className="la-card">
              <img
                src={process.env.PUBLIC_URL + "/Images/HomePage/icon-29.png"}
                alt="Evaluations"
              />
              <span>Evaluations</span>
            </div>
          </div>

          <p className="la-caption">
            Learning is reinforced through a Capstone Project, enabling ASEs to
            apply full stack concepts to real-world scenarios while
            demonstrating end-to-end solutioning skills.
          </p>
        </section>

        <section className="ajs-wrapper">
          <div className="ajs-image">
            <img
              src={
                process.env.PUBLIC_URL + "/Images/HomePage/left-banner-img.jpg"
              }
              alt="AI Journey"
            />
          </div>

          <div className="ajs-content">
            <ul className="ajs-list">
              <li>
                Alongside technical learning, AI-augmented skills are integrated
                throughout the journey, ensuring AI is applied in context rather
                than taught in isolation.
              </li>

              <li>
                ASEs gain exposure to GenAI in the technology delivery
                lifecycle, agentic AI tools, frameworks, and cloud-native AI,
                complemented by hands-on experience with Accenture AI assets.
              </li>

              <li>
                The program is further strengthened by industry, behavioral, and
                delivery skills, producing well-rounded professionals who are
                full stack–ready, AI-augmented, continuously assessed, and
                deployment-ready with TQR certification.
              </li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HomePageContent;
